import { createContext } from 'react';

// React context for calculator state (questions, answers, config, etc.).
const calculatorsContext = createContext();

export default calculatorsContext;
